<template>
  <div>
    <div class="header">
      <div class="uk-navbar-container">
        <div class="uk-container">
          <nav data-uk-navbar class="uk-navbar-container uk-navbar">
            <div class="uk-navbar-left">
              <template v-if="tenant.knumber === 'K10162'">
              <a href="#" @click.prevent="doTranslate('de|de')">
                <img src="/img/lang/de.png" alt="Deutsch" class="uk-margin-small-right" />
              </a>
              <a href="#" @click.prevent="doTranslate('de|en')">
                  <img src="/img/lang/en.png" alt="Englisch" class="uk-margin-small-right" />
                </a>
                <a href="#" @click.prevent="doTranslate('de|it')">
                  <img src="/img/lang/it.png" alt="Italienisch" class="uk-margin-small-right" />
                </a>
                </template>
            </div>
            <div class="uk-navbar-right">
              <ul class="uk-navbar-nav" v-if="tenant">
                <li>
                  <a :href="'mailto:' + tenant.email">{{ tenant.email }}</a>
                </li>
                <li>
                  <a :href="'tel:' + tenant.phoneLink">{{ tenant.phone }}</a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <div
      class="uk-position-z-index uk-flex uk-flex-middle uk-flex-center uk-position-relative"
    >
      <router-view></router-view>
    </div>
    <div
      class="footer uk-text-small uk-section uk-section-xsmall uk-section-secondary"
      style="background: #222"
    >
      <div class="uk-container">
        <div class="uk-grid uk-flex uk-flex-middle uk-grid-small" data-uk-grid>
          <div class="uk-width-auto@m">
            <ul class="uk-subnav uk-subnav-divider">
              <li>
                <a :href="tenant.imprintLink" target="_blank">
                  Impressum
                </a>
              </li>
              <li>
                <a :href="tenant.privacyLink" target="_blank">
                  Datenschutz
                </a>
              </li>
            </ul>
          </div>
          <div class="uk-width-expand">
            <div class="uk-align-right@m">
              © {{ year }} {{ tenant.company }} | {{ tenant.street }} | {{ tenant.zipcode }}
              {{ tenant.city }} | powered by
              <a href="https://www.ackermann-netsolution.de" target="_blank" class="uk-link-reset"
                >ACKERMANN-netsolution</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Configuration from '@/configuration';
export default {
  beforeCreate() {
    //document.body.className = `login uk-cover-container uk-background-secondary uk-flex uk-flex-center uk-flex-middle uk-height-viewport uk-overflow-hidden`
    document.body.classList.add('login')
    document.documentElement.classList.add(`theme-${Configuration.value('client')}`)
  },
  destroyed() {
    document.body.classList.remove('login')
    document.documentElement.classList.remove(`theme-${Configuration.value('client')}`)
  },
  mounted() {
    this.fetchTenant()
    if(Configuration.value('client') === 'daleo') {
      //this.googleTranslateInit()
    }
  },
  computed: {
    ...mapGetters({ tenant: 'tenant' }),
    year() {
      return new Date().getFullYear()
    }
  },
  methods: {
    ...mapActions({ fetchTenant: 'auth/fetchTenant' }),
    doTranslate(lang_pair) {
      const lang = lang_pair.split("|")[1];
      if (this.getCurrentLang == null && lang == lang_pair.split("|")[0]) return;
      let teCombo;
      var sel = document.getElementsByTagName("select");
      for (var i = 0; i < sel.length; i++)
          if (sel[i].className.indexOf("goog-te-combo") != -1) {
              teCombo = sel[i];
              break;
          }
      if (document.getElementById("google_translate_element2") == null || document.getElementById("google_translate_element2").innerHTML.length == 0 || teCombo.length == 0 || teCombo.innerHTML.length == 0) {
          setTimeout(() => {
            this.doTranslate(lang_pair);
          }, 500);
      } else {
          teCombo.value = lang;
          this.fireTranslateEvent(teCombo, "change");
          this.fireTranslateEvent(teCombo, "change");
      }
    },
    getCurrentLang() {
      var keyValue = document["cookie"].match("(^|;) ?googtrans=([^;]*)(;|$)");
      return keyValue ? keyValue[2].split("/")[2] : null;
    },
    fireTranslateEvent(element, event) {
      try {
          if (document.createEventObject) {
              const evt = document.createEventObject();
              element.fireEvent("on" + event, evt);
          } else {
              const evt2 = document.createEvent("HTMLEvents");
              evt2.initEvent(event, true, true);
              element.dispatchEvent(evt2);
          }
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>
